import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    next: 'Confirm my PIN code',
    subtitle:
      'Create a secret code to secure your transactions with this card.',
    title: 'Choose your PIN code',
  },
  fr: {
    next: 'Confirmer mon code PIN',
    subtitle:
      'Créez un code secret pour sécuriser vos opérations avec cette carte.',
    title: 'Choisissez votre code PIN',
  },
} as const);

export default locales;
